const normalizeAndCapitalize = (input: string) => {
  // Replace camelCase with spaces between words
  const camelToSpace = input.replace(/([a-z])([A-Z])/g, '$1 $2');

  // Replace snake_case with spaces between words
  const snakeToSpace = camelToSpace.replace(/_/g, ' ');

  // Capitalize each word
  const capitalized = snakeToSpace
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');

  return capitalized;
};

const createTableColumns = (cols: string[]) => {
  return cols.map((col) => {
    const normalizedCol = normalizeAndCapitalize(col);

    const parseValue = (value:any) => {
      if(value === true) return '✔';

      if(col !=='createdAt') return value;

      const options: Intl.DateTimeFormatOptions = {
        timeZone: "UTC",
        year: "numeric",
        month: "long",  
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        hour12: true,
      };
      
      const formattedDate = new Intl.DateTimeFormat("en-US", options).format(new Date(value));

      return formattedDate + " UTC";
    };

    return {
      accessorFn: (row: any) => row[col],
      id: col,
      cell: (info: any) => (parseValue(info.getValue()) || '').toString(),
      header: normalizedCol,
      footer: (props: any) => props.column.id,
    };
  });
};

const stringToColor = (input: string): string => {
  let hash = 0;
  for (let i = 0; i < input.length; i++) {
    hash = input.charCodeAt(i) + ((hash << 5) - hash);
  }

  const hue = hash % 360;
  const saturation = 60 + (hash % 20);
  const lightness = 50 + (hash % 10);

  return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
};

export { normalizeAndCapitalize, createTableColumns, stringToColor };